import Vue from 'vue';

Vue.component('promotion-report-index', () =>
    import(/* webpackChunkName: 'promotion-report-index' */ './promotion-report-index.vue'),
);

Vue.component('promotion-report-table', () =>
    import(/* webpackChunkName: 'promotion-report-table' */ './promotion-report-table.vue'),
);
